'use strict';

var Backbone = require('backbone');
var Location = require('../models/location').default;

var LocationCollection = Backbone.Collection.extend({

  url: '/online_bookings/ajax_locations',
  model: Location,

  initialize: function (models, options) {
    options = options || {};
    this.latitude = options.latitude || null;
    this.longitude = options.longitude || null;
  },

  parse: function (response) {
    return response.data.location;
  },

  setPosition: function (latitude, longitude) {
    this.latitude = latitude;
    this.longitude = longitude;
  },

  searchByKeyword: function (q) {
    var models = this.filter(function (location) {
      if (location.get('city').toLowerCase().indexOf(q.toLowerCase()) !== -1) {
        return true;
      }

      if (location.get('name').toLowerCase().indexOf(q.toLowerCase()) !== -1) {
        return true;
      }

      return false;
    });

    return new LocationCollection(models);
  },

  searchByPositionAndDistance: function (latitude, longitude, distance) {
    var self = this;
    var models = this.filter(function (location) {
      return location.distanceFromPoint(latitude, longitude) < distance;
    });

    var collection = new LocationCollection(models);
    collection.setPosition(latitude, longitude);
    collection.sort();

    return collection;
  },

  getByService: function (service) {
    var collection = new LocationCollection(this.filter(function (location) {
      return location.hasService(service);
    }));
    collection.setPosition(this.latitude, this.longitude);

    return collection;
  },

  getByStaff: function (staff) {
    var collection = new LocationCollection(this.filter(function (location) {
      return location.hasStaff(staff);
    }));
    collection.setPosition(this.latitude, this.longitude);

    return collection;
  },

});

LocationCollection = LocationCollection.extend({
  comparator: function (a, b) {
    if (a.get('virtual') && !b.get('virtual')) {
      return -1;
    }

    if (b.get('virtual') && !a.get('virtual')) {
      return 1;
    }

    if (!(this.latitude && this.longitude)) {
      if (a.get('sort_order') > b.get('sort_order')) {
        return 1;
      }

      if (a.get('sort_order') < b.get('sort_order')) {
        return -1;
      }

      return 0;
    }

    var distance1 = a.distanceFromPoint(this.latitude, this.longitude);
    var distance2 = b.distanceFromPoint(this.latitude, this.longitude);

    if (distance1 > distance2) {
      return 1;
    }

    if (distance1 < distance2) {
      return -1;
    }

    return 0;
  },
});

export default LocationCollection;
